/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_themes/ClassicTheme.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Mon Apr 21 2025
 */

import React, { useContext } from 'react';
import { FormContext } from "@proxy/_contexts";
import GiftCardDetail from "@proxy/pages/GiftCardDetail";
import {
  SendMultipleButton,
  SendSingleButton,
} from "@proxy/_components";  
import {
  ContentBottom,
  ContentTop,
  FormBreadcrumbs,
  FormElement,
  PreviewBanner,
} from "../_sections";

type ClassicThemeProps = {
  previewVisible: boolean;
  previewData: any;
  bulkTranslations: any;
  togglePreview: () => void;
};

const ClassicTheme = ({
  previewVisible,
  previewData,
  bulkTranslations,
  togglePreview,
}: ClassicThemeProps) => {

  const {
    loading,
    preview,
    previewSettings,
    inDashboard,
    settings,
    currency,
    currentStep,
    bulkOrder,
    fulfillmentType,
  } = useContext(FormContext);

  return ((!loading) ?
    <>
      {(bulkOrder === false) ? <ContentTop /> : null}
      <div className="gc__layout_wrapper">
        <div id="gcpPurchaseFormWrapper">
          <FormBreadcrumbs />
          <div className={`gc__giftcard_page gc__step_${currentStep}`}>
            <FormElement
              togglePreview={togglePreview}
            />
          </div>
        </div>

        {(bulkOrder === false) ?
          <div className={previewVisible === true ? "gc__giftcard_preview" : "gc__giftcard_preview gc__hidden_mobile"}>
            {(bulkOrder === true)
              ? <SendSingleButton bulkTranslations={bulkTranslations} />
              : <SendMultipleButton bulkTranslations={bulkTranslations} />
            }
            <PreviewBanner />
            <GiftCardDetail
              currentStep={currentStep}
              previewVisible={previewVisible}
              togglePreview={togglePreview}
              previewSettings={(preview) ? previewSettings : settings}
              preview={true}
              giftCardData={previewData}
              moneyFormat={(currency.isInternational) ? currency.moneyFormat : null}
              isMarketsCurrency={currency.isInternational}
              fulfillmentType={fulfillmentType}
              inDashboard={inDashboard}
            />
          </div>
        : null}
      </div>
      <ContentBottom />
    </>
  : null);
};

export default ClassicTheme;
